import Vue from 'vue'
import Router from 'vue-router'
import { Notification, MessageBox, Message, Loading } from 'element-ui';
import {commonConstant} from '@/utils/Constants';
import commonUtil from '@/utils/commonUtil';
import {i18n} from '@/utils/i18nUtil.js';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login')
    },
    {
      path:'*',
      component: () => import('@/views/404')
    },
    {
      path:'/deviceManualList',
      component: () => import('@/views/deviceManualList')
    },
    {
      path: '/home',
      name: 'home',
      meta:{title:"首页"},
      component: () => import('@/views/main'),
      children:[
        /* 二级路由 */
        {
          path: 'welcome',
          name: 'welcome',
          // 属性名与router-view :name绑定解决切换el-tab时重复调用挂载或created问题
          components: {"welcome":() => import('@/views/welcome')}
        },
        {
          path: 'messageLog',
          name: 'message-log',
          meta:{title:"设备管理 / 消息队列日志"},
          components: {"message-log":() => import('@/views/device/messagelog')}
        },
        {
          path: 'upRecord',
          name: 'up-record',
          meta:{title:"设备管理 / 上电记录"},
          components: {"up-record":() => import('@/views/device/upRecord')}
        },
        {
          path: 'deviceList',
          name: 'device-list',
          meta:{title:"设备管理 / 设备列表"},
          components: {"device-list":() => import('@/views/device/deviceList')}
        },
        {
          path: 'projectList',
          name: 'project-list',
          meta:{title:"项目管理 / 项目列表"},
          components: {"project-list":() => import('@/views/project/projectList')}
        },
        {
          path: 'customers',
          name: 'customers',
          meta:{title:"用户管理"},
          components: {"customers":() => import('@/views/customers')}
        },
        {
          path: 'callRecord',
          name: 'call-record',
          meta:{title:"设备管理 / 通话记录"},
          components: {"call-record":() => import('@/views/device/callRecord')}
        },
        {
          path: 'deviceLevelUp',
          name: 'device-level-up',
          meta:{title:"设备管理 / 升级管理"},
          components: {"device-level-up":() => import('@/views/device/deviceLevelUp')}
        },
        {
          path: 'iotLog',
          name: 'iot-log',
          meta:{title:"物联网卡管理 / 接口操作日志"},
          components: {"iot-log":() => import('@/views/iot/iotLog')}
        },
        {
          path: 'voiceIotTibiot',
          name: 'voice-iot-tibiot',
          meta:{title:"物联网卡管理 / 语音物联网卡-齐犇"},
          components: {"voice-iot-tibiot":() => import('@/views/iot/voiceIotTibiot')}
        },
        {
          path: 'flowIotShingsou',
          name: 'flow-iot-shingsou',
          meta:{title:"物联网卡管理 / 流量物联网卡-旭宇"},
          components: {"flow-iot-shingsou":() => import('@/views/iot/flowIotShingsou')}
        },
        {
          path: 'projectGroup',
          name: 'project-group',
          meta:{title:"项目管理 / 项目组"},
          components: {"project-group":() => import('@/views/project/projectGroup')}
        },
        {
          path: 'iotReplace',
          name: 'iot-replace',
          meta:{title:"物联网卡管理 / 换卡记录"},
          components: {"iot-replace":() => import('@/views/iot/iotReplaceRecord')}
        },
        {
          path: 'role',
          name: 'system-role',
          meta:{title:"系统管理 / 角色权限"},
          components: {"system-role":() => import('@/views/system/role')}
        },
        {
          path: 'operationLog',
          name: 'system-operation-log',
          meta:{title:"系统管理 / 操作日志"},
          components: {"system-operation-log":() => import('@/views/system/operLog')}
        },
        {
          path: 'onlineUsers',
          name: 'system-online-users',
          meta:{title:"系统管理 / 在线用户"},
          components: {"system-online-users":() => import('@/views/system/onlineUsers')}
        },
        {
          path: 'firstPlatformData',
          name: 'first-platform-data',
          meta:{title:"设备管理 / 1代平台数据"},
          components: {"first-platform-data":() => import('@/views/device/firstPlatformData')}
        },
        {
          path: 'bigScreenDataView',
          name: 'big-screen-data-view',
          meta:{title:"大屏数据可视化"},
          components: {"big-screen-data-view":() => import('@/views/bigScreenDataView')}
        },
        {
          path: 'elevatorDataBigScreen',
          name: 'elevator-data-big-screen',
          meta:{title:"电梯大数据可视化"},
          components: {"elevator-data-big-screen":() => import('@/views/bigScreenDataView')}
        },
        {
          path: 'deviceRechargeInfo',
          name: 'device-recharge-info',
          meta:{title:"设备管理 / 充值定价信息"},
          components: {"device-recharge-info":() => import('@/views/device/rechargeInfo')}
        },
        {
          path: 'deviceRechargeRules',
          name: 'device-recharge-rules',
          meta:{title:"设备管理 / 充值定价规则"},
          components: {"device-recharge-rules":() => import('@/views/device/rechargeRules')}
        },
        {
          path: 'sysFile',
          name: 'system-file-mgt',
          meta:{title:"系统管理 / 文件管理"},
          components: {"system-file-mgt":() => import('@/views/system/sysFile')}
        },
        {
          path: 'deviceManual',
          name: 'device-manual',
          meta:{title:"设备管理 / 设备手册"},
          components: {"device-manual":() => import('@/views/device/manual')}
        },
        {
          path: 'deviceLifeCycle',
          name: 'device-life-cycle',
          meta:{title:"设备生命周期记录"},
          components: {"device-life-cycle":() => import('@/views/device/lifeCycle')}
        },
      ]
    },
  ]
});

//路由守卫
router.beforeEach(async (to, from, next) => {
  let authorization = commonUtil.getLoginToken();
  if(authorization != null || to.path == '/' || to.path == '/deviceManualList'){//如果登录过、去登录页
    next();
  }else{//没登录
    Message.error(i18n.t('login.notLogin'));
    // Message.error("Illegal Access,Please Login!");
    next("/");
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js